import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { BoxItem } from '@ravago/shared/radiance/components/box/components/BoxItem/BoxItem';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { IconButton } from '@ravago/shared/radiance/components/button/components/IconButton/IconButton';
import { Flyout } from '@ravago/shared/radiance/components/flyout/components/Flyout/Flyout';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { ProductPriceCardItem } from '../models/product-price-card-item.model';
import { ProductPriceListFiltersValue } from '../models/product-price-list-filters-value';

import { ProductPriceListFilterFields } from './product-price-list-filter-fields';

interface Props {
   open: boolean;
   productPriceCardItems: ProductPriceCardItem[];
   value: ProductPriceListFiltersValue;
   onChange: (value: ProductPriceListFiltersValue) => void;
   onClear: () => void;
   onClose: () => void;
}

export const ProductPriceListFilterFlyout = ({ open, productPriceCardItems, value, onChange, onClear, onClose }: Props) => {
   const translate = useTranslations();

   return (
      <Flyout width="100%" open={open} usePortal position="right" onFlyoutClose={onClose} closeOnOutsideClick>
         <Box height="100%" direction="column" gap="none">
            <Box justify="between" items="center" spacing="xl">
               <Typography component="h4" variant="heading-4" color="strong">
                  {translate('filter.filters')}
               </Typography>
               <IconButton icon="chevron-right" ariaLabel="close" onClick={onClose} />
            </Box>

            <BoxItem grow={1} overflowY="auto">
               <Box spacing={{ left: 'md', right: 'md' }} direction="column" gap="md">
                  <ProductPriceListFilterFields productPriceCardItems={productPriceCardItems} value={value} onChange={onChange} />
               </Box>
            </BoxItem>

            <Box spacing="md" gap="xs" direction="column" items="center">
               <Button variant="secondary" onClick={onClear} fullWidth>
                  {translate('filter.clear-all-filters')}
               </Button>
               <Button variant="primary" onClick={onClose} fullWidth>
                  {translate('filter.show-results')}
               </Button>
            </Box>
         </Box>
      </Flyout>
   );
};
